module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjhzs_loading",
    style: (_vm.setcss)
  }, [_vm._t("loading_bg"), _vm._v(" "), (_vm.havemask) ? _c('maskdiv', {
    attrs: {
      "auto": false,
      "parentNode": this
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'loading' + ' ' + 'loading_' + _vm.size
  }, [_c('div', {
    staticClass: "circle-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle-2"
  }), _vm._v(" "), (_vm.haveinfo) ? _c('span', {
    staticClass: "loading_info"
  }, [_vm._v(_vm._s(_vm.loading_info))]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2883d84e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/Loading.vue
// module id = 168
// module chunks = 1